import commitThemeChange from './orchestration/commitThemeChange';
import discardThemeChange from './orchestration/discardThemeChange';
import isThemePreviewDirty from './utils/isThemePreviewDirty';
import ThemeFull from './view/ThemeFull';
import ThemeQuick from './view/ThemeQuick';
import { Option, QuickSettingOrder } from 'owa-options-core';
import { OwaWorkload } from 'owa-workloads';
import * as React from 'react';

let ThemeOption: Option = {
    key: 'theme',
    titleStringKey: 'optionTitle_Theme',
    searchTermsStringKey: 'optionSearch_Theme',
    fullOptionFormSettings: {
        render: () => <ThemeFull />,
        isDirty: isThemePreviewDirty,
        onSave: commitThemeChange,
        onDiscard: discardThemeChange,
    },
    quickOptionSettings: {
        rendering: {
            render: () => <ThemeQuick />,
        },
        getOrder: () => QuickSettingOrder.Theme,
        workloads: OwaWorkload.All,
    },
    allowedOptionKeys: ['Theme'],
};

export default ThemeOption;
